import React from 'react'
import {NavLink} from "react-router-dom";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";

/**
 * Kopfbereich der öffentlichen Seiten im neuen Design (Events, Veranstalter).
 *
 * @param pfad Einträge der Brotkrumen nach "Events", jeweils {label, to}; ohne "to" ist es der aktuelle Eintrag
 * @param meta Eckdaten unter dem Titel, jeweils {icon, text}
 * @param ohneTopbar blendet die Leiste mit Logo und Brotkrumen aus (z.B. Live-Seite in der App)
 */
export default function SeitenKopf({pfad, chip, titel, meta, appCall, ohneTopbar = false, children}) {
    return <header>
        {!ohneTopbar && <div className="dhpt-topbar">
            {appCall
                ? <img alt="Darthelfer" src={"/images/darthelfer_quer_weiss.png"} className="dhpt-logo"/>
                : <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route} aria-label="Zur Eventübersicht">
                    <img alt="Darthelfer" src={"/images/darthelfer_quer_weiss.png"} className="dhpt-logo"/>
                </NavLink>
            }
            {!appCall &&
                <nav className="dhpt-crumb" aria-label="Brotkrumen">
                    <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route}>Events</NavLink>
                    {(pfad || []).map(eintrag => <React.Fragment key={eintrag.label}>
                        <i className="pi pi-chevron-right" aria-hidden="true"/>
                        {eintrag.to ? <NavLink to={eintrag.to}>{eintrag.label}</NavLink> : <span className="dhte-crumb-aktuell">{eintrag.label}</span>}
                    </React.Fragment>)}
                </nav>
            }
        </div>}
        <div className="dhpt-hero">
            {chip && <div className="dhpt-hero-zeile">{chip}</div>}
            <h1 className="dhpt-titel">{titel}</h1>
            {meta && meta.length > 0 &&
                <div className="dhpt-meta">
                    {meta.map(eintrag => <span key={eintrag.text}><i className={eintrag.icon} aria-hidden="true"/>{eintrag.text}</span>)}
                </div>
            }
            {children}
        </div>
    </header>
}
